module.exports = "<div>\r\n  <h1>Under construction.</h1>\r\n  <p class=\"lead\">We are working hard to bring to you our great project soon.</p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/+admin/components/under-construction/under-construction.component.html
// module id = 1124
// module chunks = 0